
import AccountingListingMapping from 'vcomponents/listing/apiListing/mapping/AccountingListingMapping.js';
import BankAccountingListingMapping from 'vcomponents/listing/apiListing/mapping/BankAccountingListingMapping.js';
import MiscAccountingListingMapping from 'vcomponents/listing/apiListing/mapping/MiscAccountingListingMapping.js';
export default [
    {
        id: "accounting-sell",
        label: window.i18n.__("Journal des ventes"),
        buttons: [],
        enableExport: true,
        enableKpisOnExport: false,
        enableFiltering: true,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "accountingEntry",
        name: "accounting-sell",
        params: {},
        prefilter: {},
        url: "/accounting-journal/sells/search",
        metaUrl: "/accounting-journal/sells/metas",
        exportUrl: "/accounting-journal/sells/export",
        useFavorites: false,
        favoritesName: 'accounting-sell',
        listingMapping: AccountingListingMapping,
        aggregations: ['credit_debit'],
        exportFormats: ["csv", "fec"]
    },
    {
        id: "accounting-purchase",
        label: window.i18n.__("Journal des achats"),
        buttons: [],
        enableExport: true,
        enableKpisOnExport: false,
        enableFiltering: true,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "accountingEntry",
        name: "accounting-purchase",
        params: {},
        prefilter: {},
        url: "/accounting-journal/purchases/search",
        metaUrl: "/accounting-journal/purchases/metas",
        exportUrl: "/accounting-journal/purchases/export",
        useFavorites: false,
        favoritesName: 'accounting-purchase',
        listingMapping: AccountingListingMapping,
        aggregations: ['credit_debit'],
        exportFormats: ["csv", "fec"]
    },
    {
        id: "accounting-bank",
        label: window.i18n.__("Journal de banque"),
        buttons: [],
        enableExport: true,
        enableKpisOnExport: false,
        enableFiltering: true,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "accountingEntry",
        name: "accounting-bank",
        params: {},
        prefilter: {},
        url: "/accounting-journal/bank/search",
        metaUrl: "/accounting-journal/bank/metas",
        exportUrl: "/accounting-journal/bank/export",
        useFavorites: false,
        favoritesName: 'accounting-bank',
        listingMapping: BankAccountingListingMapping,
        aggregations: ['credit_debit'],
        exportFormats: ["csv", "fec"]
    },
    {
        id: "accounting-cashtill",
        label: window.i18n.__("Journal de caisse"),
        buttons: [],
        enableExport: true,
        enableKpisOnExport: false,
        enableFiltering: true,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "accountingEntry",
        name: "accounting-cashtill",
        params: {},
        prefilter: {},
        url: "/accounting-journal/cashtill/search",
        metaUrl: "/accounting-journal/cashtill/metas",
        exportUrl: "/accounting-journal/cashtill/export",
        useFavorites: false,
        favoritesName: 'accounting-cashtill',
        listingMapping: AccountingListingMapping,
        aggregations: ['credit_debit'],
        exportFormats: ["csv", "fec"]
    },
    {
        id: "accounting-misc",
        label: window.i18n.__("Journal des opérations diverses"),
        alert: {
            text: window.i18n.__("Seules les écritures concernant la TVA sur les encaissements sont visibles dans ce journal."),
            enabled: true
        },
        buttons: [],
        enableExport: true,
        enableKpisOnExport: false,
        enableFiltering: true,
        enableOptions: true,
        enableContext: true,
        endpoint: '',
        exportOptions: {},
        favorite: null,
        filter: {},
        filtersComponent: undefined,
        linkedtype: "accountingEntry",
        name: "accounting-misc",
        params: {},
        prefilter: {},
        url: "/accounting-journal/misc/search",
        metaUrl: "/accounting-journal/misc/metas",
        exportUrl: "/accounting-journal/misc/export",
        useFavorites: false,
        favoritesName: 'accounting-misc',
        listingMapping: MiscAccountingListingMapping,
        aggregations: ['credit_debit'],
        exportFormats: ["csv", "fec"]
    },
]
